import gsap, { Power3, Power1 } from "gsap";

import { GetBy } from "../_app/cuchillo/core/Element";
import { isDebug } from '../_app/cuchillo/core/Basics';
import Header from "./Header";

export default class Preloader {
    _container;
    _progress;
    _thumb;
    _isInit = false;

    static init() {
        this._container = GetBy.id('Preloader');

        if (isDebug) {
            this._container.style.display = "none";
            return;
        }

        this._thumb = GetBy.class('__thumb', this._container)[0];
        this._progress = GetBy.class('__progress', this._container)[0];
    }

    static show() {
        gsap.killTweensOf(this._progress);
        gsap.to(this._progress, {
            scaleX: '100%',
            ease: Power3.easeOut,
            duration: .5,
            onComplete: () => {
                this.isInit = true;
            }
        });
    }

    static update(__progress) {
        if (isDebug) return;

        if (!this.isInit) this.show();

        gsap.killTweensOf(this._thumb);
        gsap.to(this._thumb, {
            scaleX: __progress,
            ease: Power1.easeOut,
            duration: .1
        });
    }

    static hide(__call) {
        if (isDebug) {
            this._container.style.display = "none";
            if (__call) __call();
            return;
        }

        let delay = 0;
        if (!this.isInit) {
            this.show();
            delay += .5;
        }

        gsap.killTweensOf(this._thumb);
        gsap.to(this._thumb, {
            scaleX: '100%',
            ease: Power3.easeOut,
            duration: .8,
            delay,
            onComplete: () => {
                this._progress.style.transformOrigin = 'center right';
            }
        });

        delay += 1.2;
        gsap.to(this._progress, {
            scaleX: 0,
            ease: Power3.easeOut,
            duration: .5,
            delay
        });

        delay += .8;
        gsap.delayedCall(delay, () => {
            Header.directShowLogo();
        });

        delay += 1.5;
        gsap.to(this._container, {
            opacity: 0,
            ease: Power3.easeOut,
            duration: .7,
            delay,
            onComplete: () => {
                this._container.style.display = "none";
                if (__call) __call();
            }
        });
    }
}
